export default [
  {
    name: "Metodrum 1",
    id: "ea048bf7-1707-4263-b236-32d7ce428da0",
  },
  {
    name: "Metodrum 2",
    id: "dcdb9155-a486-4a93-bb04-025d08da7bbc",
  },
  {
    name: "Övrigt rum",
    id: "201d7778-8785-4f19-95aa-8624716e0f91",
  },
];
